module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close"},"de":{"close":"Schliessen"}}')
  delete Component.options._Ctor
}
